import { apiAction, apiFetch, getMetaContent } from '../utils';
import DuckEntity from './DuckEntity'

const duck = new DuckEntity('schoolYears')

const setDefaultForReporting = schoolYearId => {
  const token = getMetaContent('csrf-token')
  const headers = { Accept: 'application/json', 'X-CSRF-Token': token }

  return (
    apiAction(
      duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
      state => (
        apiFetch.put(
          state,
          `school_years/${schoolYearId}/set_default_for_reporting`,
          null,
          { headers }
        )
      )
    )
  )
}

const entity = {
  ...duck,
  actions: {
    ...duck.actions,
    setDefaultForReporting
  }
}

const reducer = duck.reducer

export { reducer as default, entity }
